var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 2.25H4.25C3.425 2.25 2.75 2.925 2.75 3.75V14.25C2.75 15.075 3.425 15.75 4.25 15.75H14.75C15.575 15.75 16.25 15.075 16.25 14.25V3.75C16.25 2.925 15.575 2.25 14.75 2.25ZM13.25 14.25H5.75V14.07C6.815 13.215 8.12 12.75 9.5 12.75C10.88 12.75 12.185 13.215 13.25 14.07V14.25ZM14.75 13.395C13.4 12.0675 11.5475 11.25 9.5 11.25C7.4525 11.25 5.6 12.0675 4.25 13.395V3.75H14.75V13.395ZM9.5 9.75C10.9475 9.75 12.125 8.5725 12.125 7.125C12.125 5.6775 10.9475 4.5 9.5 4.5C8.0525 4.5 6.875 5.6775 6.875 7.125C6.875 8.5725 8.0525 9.75 9.5 9.75ZM9.5 6C10.1225 6 10.625 6.5025 10.625 7.125C10.625 7.7475 10.1225 8.25 9.5 8.25C8.8775 8.25 8.375 7.7475 8.375 7.125C8.375 6.5025 8.8775 6 9.5 6Z",
    fill: "#6C1CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDetails);
export default __webpack_public_path__ + "static/media/account-details.126a6066dfb1f88f5ad28604c43de950.svg";
export { ForwardRef as ReactComponent };